<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { NIcon } from '@novonordisk/studyhub-novoui/vue'
import { useErrorStore } from '@/store/error.ts'

const errorStore = useErrorStore()

const { clearError } = errorStore
const { error } = storeToRefs(errorStore)
</script>

<template>
  <div>
    <VDialog
      :close-on-click-outside="!error.persistent"
      :model-value="error.active"
      :persistent="error.persistent"
      @update:model-value="clearError(false)"
      @keydown.esc="clearError(false)"
      data-test="dialog"
    >
      <VDialogCard
        class="w-[550px]"
        :hide-close="error.persistent"
        @close="clearError(false)"
        data-test="dialog-card"
      >
        <template #title>
          <div class="flex">
            <NIcon
              v-if="error.icon"
              :icon="error.icon"
              class="fill-general-primary mr-4"
              data-test="icon"
              :size="16"
            />
            <span
              v-if="error.title"
              data-test="title"
              >{{ error.title }}</span
            >
          </div>
        </template>
        <div
          v-if="error.description"
          data-test="description"
        >
          {{ error.description }}
        </div>
        <template #actions>
          <VButton
            :variant="error.buttonStyle ?? 'outlineSubtle'"
            size="medium"
            :loading="error.loading"
            @click="clearError()"
            data-test="button"
          >
            {{ error.buttonText || 'Close' }}
          </VButton>
        </template>
      </VDialogCard>
    </VDialog>
  </div>
</template>
